import { render } from "./BIcon.vue?vue&type=template&id=1297015e&scoped=true"
import script from "./BIcon.vue?vue&type=script&lang=js"
export * from "./BIcon.vue?vue&type=script&lang=js"

import "./BIcon.vue?vue&type=style&index=0&id=1297015e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1297015e"]])

export default __exports__